import { HttpClient } from '@angular/common/http';
import { map, switchMap, takeWhile } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { interval } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var RETRY_DELAY = 5000;
var PolicyService = /** @class */ (function () {
    function PolicyService(http) {
        this.http = http;
    }
    PolicyService.prototype.getPremiumDiscounts = function (subBranch, commercialAlternativeKey) {
        if (subBranch === void 0) { subBranch = ''; }
        var commercialAlternativeKeyUrl = commercialAlternativeKey ? "&commercialAlternativeKey=" + commercialAlternativeKey : '';
        var baseUrl = environment.server.api.portalpas;
        return this.http.get(baseUrl + "/PremiumDiscounts?subBranch=" + subBranch + commercialAlternativeKeyUrl)
            .pipe(map(function (response) {
            return response.premiumDiscounts.map(function (item) {
                return {
                    key: String(item.key),
                    name: item.name
                };
            });
        }));
    };
    PolicyService.prototype.getPremiumDiscountsBasedOnAG = function (publicId, branch, subbranch) {
        if (!publicId) {
            return this.getPremiumDiscounts(subbranch);
        }
        var url = environment.server.api.portalpas + "/affinitygroup/" + publicId + "/commercial-alternative" +
            ("?branch=" + branch + "&subbranch=" + subbranch);
        return this.http.get(url).pipe(map(function (items) { return items; }));
    };
    PolicyService.prototype.getAutomaticAdjustments = function () {
        return this.http.get(environment.server.api.dynamo + "/TypeList/name/Ext_AutomaticAdjustSum")
            .pipe(map(function (response) { return response.data.items.splice(1); }));
    };
    PolicyService.prototype.getAutomaticAdjustmentsTypeList = function (effectiveDate, expirationDate) {
        var baseUrl = environment.server.api.portalpas;
        return this.http.get(baseUrl + "/AutomaticAdjustments/auto/-1?effectiveDate=" + effectiveDate + "&expirationDate=" + expirationDate);
    };
    PolicyService.prototype.getAffinityGroups = function (policyPeriodId) {
        return this.http.get(environment.server.api.policy + "/Policy/AffinityGroup?policyPeriodId=" + policyPeriodId, { headers: { 'x-id': policyPeriodId } })
            .pipe(map(function (response) { return response['affinityGroups']; }));
    };
    PolicyService.prototype.getAffinityGroupsV3 = function (policyPeriodId) {
        var url = environment.server.api.portalpas + "/Policy/" + policyPeriodId + "/AffinityGroups";
        return this.http.get(url).pipe(map(function (response) { return response.affinityGroups; }));
    };
    PolicyService.prototype.updateAffinityGroup = function (policyPeriodId, affinityGroup) {
        var url = environment.server.api.portalpas + "/Policy/" + policyPeriodId + "/AffinityGroups";
        return this.http.put(url, affinityGroup);
    };
    PolicyService.prototype.getAffinityGroupDiscounts = function (affinityGroupId, branch, subbranch) {
        var params = { params: { affinityGroupId: affinityGroupId, branch: branch, subbranch: subbranch } };
        return this.http.get(environment.server.api.policy + "/Policy/v3/AffinityGroupDiscounts", params)
            .pipe(map(function (response) { return response['data'].items; }));
    };
    PolicyService.prototype.checkStatus = function (policyPeriodId, observer$, maxRetries, currentAttempt) {
        var _this = this;
        if (maxRetries === void 0) { maxRetries = 20; }
        if (currentAttempt === void 0) { currentAttempt = 1; }
        if (this.policyStatusSubscription$) {
            this.policyStatusSubscription$.unsubscribe();
        }
        this.policyStatusSubscription$ = this.policyStatus$(policyPeriodId, maxRetries).subscribe(function (data) {
            if (data.status === 'Bound') {
                _this.policyStatusSubscription$.unsubscribe();
                observer$.next(data);
                observer$.complete();
            }
        }, function (error) { return observer$.error(error); }, function () {
            if (currentAttempt < maxRetries) {
                _this.checkStatus(policyPeriodId, observer$, maxRetries, ++currentAttempt);
            }
        });
    };
    PolicyService.prototype.getStatus = function (policyPeriodId) {
        return this.http.get(environment.server.api.policy + "/Policy/v3/PolicyStatus?policyPeriodId=" + policyPeriodId);
    };
    PolicyService.prototype.deletePolicyJob = function (policyPeriodId) {
        var url = environment.server.api.policy + "/Policy/PolicyJob?PolicyPeriodId=" + policyPeriodId;
        return this.http.delete(url);
    };
    PolicyService.prototype.policyStatus$ = function (policyPeriodId, maxRetries) {
        var _this = this;
        var currentRetry = 0;
        return interval(RETRY_DELAY).pipe(switchMap(function () {
            currentRetry++;
            return _this.getStatus(policyPeriodId);
        }), takeWhile(function () { return currentRetry < maxRetries; }));
    };
    PolicyService.prototype.getBranchesList = function () {
        return this.http.get(environment.server.api.policy + "/PolicyRenewals/BranchesList");
    };
    PolicyService.prototype.setCommercialAlternative = function (request) {
        var url = environment.server.api.portalpas + "/Policy/" + request.policyPeriodId + "/commercial-alternative";
        var body = { PercentageValue: parseInt(request.policy.premiumDiscountKey, 10) };
        return this.http.put(url, body);
    };
    PolicyService.prototype.detachTemplate = function (policyPeriodId, templateID) {
        var url = environment.server.api.policy + "/Policy/DetachTemplate" +
            ("?policyPeriodId=" + policyPeriodId + "&templateID=" + templateID);
        return this.http.delete(url);
    };
    PolicyService.prototype.setToDraft = function (policyPeriodId) {
        var url = environment.server.api.policy + "/Policy/Draft?policyPeriodID=" + policyPeriodId;
        return this.http.put(url, null);
    };
    PolicyService.prototype.setToDraftV3 = function (policyPeriodId) {
        var url = environment.server.api.policy + "/Submission/Draft?policyPeriodID=" + policyPeriodId;
        return this.http.put(url, null);
    };
    PolicyService.prototype.createDraft = function (accountNumber, cityKey, subBranch, planId) {
        var url = environment.server.api.policy +
            ("/policy/CombinedDraft?accountNumber=" + accountNumber) +
            ("&planID=" + planId) +
            ("&cityKey=" + cityKey) +
            '&channel=PortalTD' +
            ("&subBranch=" + subBranch);
        return this.http.post(url, null);
    };
    PolicyService.prototype.createDraftProxy = function (accountNumber, productCode, channelEntryCode) {
        var baseUrl = environment.server.api.portalpasProxy;
        var body = {
            accountNumber: accountNumber,
            productCode: productCode,
            channelEntryCode: channelEntryCode
        };
        return this.http.post(baseUrl + "/policycenter-policy/api/policies", body);
    };
    PolicyService.prototype.createDraftWithSubBranch = function (accountNumber, productCode, policyTypeCode) {
        var url = environment.server.api.policy + "/Submission/DraftWithSubBranch";
        var body = {
            accountNumber: accountNumber,
            productCode: productCode,
            channelEntryCode: 'PortalTD',
            policyTypeCode: policyTypeCode
        };
        return this.http.post(url, body);
    };
    PolicyService.prototype.setSubBranch = function (policyPeriodId, policyTypeCode) {
        var baseUrl = environment.server.api.portalpasProxy;
        var body = { policyTypeCode: policyTypeCode };
        return this.http.patch(baseUrl + "/policycenter-policy/api/policies/" + policyPeriodId + "/policy-type", body);
    };
    PolicyService.prototype.sendContactData = function (accountNumber, phoneNumber, email) {
        var url = environment.server.api.policy + "/Policy/Contact?accountNumber=" + accountNumber;
        var body = {
            phoneNumber: phoneNumber,
            email: email
        };
        return this.http.post(url, body);
    };
    PolicyService.prototype.updateRiskAddress = function (policyPeriodId, location) {
        var baseUrl = environment.server.api.policy;
        var city = location && location.city;
        var address = location && location.address;
        var body = {
            policyPeriodId: policyPeriodId,
            cityKey: city && city.key || '',
            cityName: city && city.name || '',
            postalCode: city && city.postalCode || '',
            streetName: address && address.streetName || '-',
            streetNumber: address && address.number || '',
            displayText: '',
            floor: address && address.floor || '',
            department: address && address.department || ''
        };
        return this.http.post(baseUrl + "/Risk/Location", body);
    };
    PolicyService.prototype.setLocation = function (policyPeriodId, locationData) {
        var baseUrl = environment.server.api.portalpas;
        return this.http.post(baseUrl + "/policy/" + policyPeriodId + "/risk-location-by-postal-code", locationData);
    };
    PolicyService.prototype.setTemplate = function (policyPeriodId, templateId) {
        var baseUrl = environment.server.api.portalpasProxy;
        return this.http.post(baseUrl + "/policycenter-policy/api/Templates/" + templateId + "/apply", { policyPeriodId: policyPeriodId });
    };
    PolicyService.prototype.templateToAllCoberables = function (policyPeriodId, templateId) {
        var baseUrl = environment.server.api.policy;
        return this.http.post(baseUrl + "/policy/TemplateToAllCoverables?policyPeriodID=" + policyPeriodId + "&templateID=" + templateId, null);
    };
    // setPaymentDetailV3 deberia eliminarse y usar siempre este metodo
    PolicyService.prototype.setPaymentData = function (policyPeriodId, paymentData) {
        var url = environment.server.api.portalpas + "/Policy/" + policyPeriodId + "/payment-data";
        var body = {
            paymentMethodKey: paymentData.paymentTypeId,
            creditCardTypeKey: paymentData.creditCardType,
            creditCardNumber: paymentData.creditCardNumber,
            cbu: paymentData.cbuNumber,
            collectorKey: paymentData.collector.code,
            sendsCuponsByKey: paymentData.sendCouponsBy.code,
            paymentInstrumentId: paymentData.paymentInstrumentId,
            isExistingPayment: !!(paymentData.paymentInstrumentId)
        };
        return this.http.post(url, body);
    };
    PolicyService.prototype.setPaymentDetailV3 = function (policyPeriodId, paymentData) {
        var url = environment.server.api.policy + "/Policy/v3/PaymentDetail";
        var request = {
            policyPeriodID: policyPeriodId,
            cbu: paymentData.cbuNumber,
            collectorKey: paymentData.collector.code,
            creditCardNumber: paymentData.creditCardNumber,
            creditCardTypeKey: paymentData.creditCardType,
            paymentMethodKey: paymentData.paymentMethodKey,
            sendsCuponsByKey: paymentData.sendCouponsBy.code,
        };
        return this.http.put(url, request);
    };
    PolicyService.prototype.setPaymentDataInCore = function (policyPeriodId, paymentTypeId, quoteNro) {
        var url = environment.server.api.policy + "/Policy/PolicyPaymentData?policyPeriodId=" + policyPeriodId;
        var body = {
            paymentMethodKey: paymentTypeId,
            paymentFee: quoteNro,
        };
        return this.http.post(url, body);
    };
    PolicyService.prototype.setPaymentDataInCoreV3 = function (policyPeriodId, paymentTypeId, quoteNro) {
        var url = environment.server.api.policy + "/Policy/v3/PolicyPaymentData?policyPeriodID=" + policyPeriodId;
        var body = {
            paymentMethodKey: paymentTypeId,
            paymentFee: quoteNro,
        };
        return this.http.post(url, body);
    };
    PolicyService.prototype.mailingAddress = function (policyPeriodId, cityData, address) {
        if (address === void 0) { address = null; }
        return this.http.put(environment.server.api.policy + "/Policy/MailingAdress", this.getMailingAddressRequest(policyPeriodId, cityData, address));
    };
    PolicyService.prototype.getMailingAddressRequest = function (policyPeriodId, city, address) {
        var state = city && city.state;
        return {
            policyPeriodId: policyPeriodId,
            postalCode: city && city.postalCode,
            streetName: address && address.street || '-',
            streetNumber: address && address.streetNumber || '-',
            floor: address && address.floor,
            department: address && address.department,
            cityName: city && city.name,
            state: {
                code: state && state.key,
                description: state && state.name
            }
        };
    };
    PolicyService.prototype.createNewPolicyVersion = function (policyPeriodId) {
        return this.http.post(environment.server.api.policy + "/PolicyRenewals/NewVersionsPeriod", { policyPeriodId: policyPeriodId }, this.headers);
    };
    PolicyService.prototype.selectedVersion = function (policyPeriodId) {
        return this.http.put(environment.server.api.policy + "/PolicyRenewals/SelectedVersion", { policyPeriodId: policyPeriodId }, this.headers);
    };
    PolicyService.prototype.electronicDocumentsMark = function (accountNumber, mark) {
        if (mark === void 0) { mark = true; }
        return this.http.put(environment.server.api.portalpas + "/Account/ElectronicDocumentsMark/" + accountNumber, {
            electronicDocumentsMark: mark
        });
    };
    PolicyService.prototype.getElectronicMarkByPolicyPeriodId = function (policyPeriodId) {
        var baseUrl = environment.server.api.portalpas;
        return this.http.get(baseUrl + "/Account/ElectronicDocumentsMarkByPolicyPeriodId?policyPeriodId=" + policyPeriodId);
    };
    PolicyService.prototype.setElectronicMarkByPolicyPeriodId = function (policyPeriodId, electronicDocumentsMark) {
        var baseUrl = environment.server.api.portalpas;
        return this.http.put(baseUrl + "/Account/ElectronicDocumentsMarkByPolicyPeriodId?policyPeriodId=" + policyPeriodId, {
            electronicDocumentsMark: electronicDocumentsMark
        });
    };
    PolicyService.prototype.primaryContactData = function (contactData, accountNumber, policyPeriodId) {
        var baseUrl = environment.server.api.policy + "/Contact/PrimaryContactDataAp";
        return this.http.post(baseUrl + "?accountNumber=" + accountNumber + "&policyPeriodId=" + policyPeriodId, contactData);
    };
    PolicyService.prototype.getPolicyStatus = function (policyPeriodId) {
        return this.http.get(environment.server.api.portalpasProxy + "/policycenter-policy/api/Policies/" + policyPeriodId + "/status");
    };
    PolicyService.prototype.getPremium = function (policyPeriodId) {
        return this.http.get(environment.server.api.portalpasProxy + "/policycenter-policy/api/Policies/" + policyPeriodId + "/premium");
    };
    PolicyService.prototype.setPaymentInfo = function (body, policyPeriodId) {
        return this.http.put(environment.server.api.portalpas + "/Policy/" + policyPeriodId + "/payment-info", body);
    };
    PolicyService.prototype.quote = function (policyPeriodId) {
        var url = environment.server.api.portalpasProxy + "/policycenter-submission/api/Quotations/" + policyPeriodId + "/quote";
        return this.http.post(url, {});
    };
    PolicyService.prototype.getPaymentInfo = function (policyNumber, policyPeriodId, withoutCache) {
        if (withoutCache === void 0) { withoutCache = false; }
        var endpoint = environment.server.api.portalpas + "/Policy/payment-info/" + policyPeriodId + "?policyNumber=" + policyNumber + "&withoutCache=" + withoutCache;
        return this.http.get(endpoint);
    };
    PolicyService.prototype.getSimplePolicyHeader = function (policyNumber) {
        return this.http.get(environment.server.api.portalpas + "/policy/header?policyNumber=" + policyNumber);
    };
    PolicyService.prototype.getMailingAddress = function (policyNumber) {
        var baseUrl = environment.server.api.portalpas;
        return this.http.get(baseUrl + "/Policy/" + policyNumber + "/mailing-address");
    };
    PolicyService.prototype.getPolicyNumberByJobNumber = function (jobNumber) {
        return jobNumber.substring(0, jobNumber.lastIndexOf('-'));
    };
    PolicyService.prototype.getEndorsementByJobNumber = function (jobNumber) {
        return jobNumber.substring(jobNumber.lastIndexOf('-') + 1, jobNumber.length);
    };
    PolicyService.prototype.deleteDraft = function (policyPeriodId) {
        var baseUrl = environment.server.api.portalpasProxy;
        return this.http.delete(baseUrl + "/policycenter-policy/api/Policies/" + policyPeriodId);
    };
    PolicyService.prototype.sendApprovalRequestProxy = function (policyPeriodId) {
        var url = environment.server.api.portalpasProxy +
            ("/policycenter-policy/api/Policies/" + policyPeriodId + "/underwriting-issues/approval-request");
        return this.http.put(url, null);
    };
    PolicyService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PolicyService_Factory() { return new PolicyService(i0.ɵɵinject(i1.HttpClient)); }, token: PolicyService, providedIn: "root" });
    return PolicyService;
}());
export { PolicyService };
